import { motion } from "framer-motion";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { HashSet } from "../../../utils/HashSet";
import { CHECK_CIRCLE } from "../../../utils/svgs";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import { AppListItem } from "../../Generic/AppList";
import Flex from "../../Generic/Flex";
import Padding from "../../Padding";
import NotesText from "../../Patient/components/NotesText";
import {
  EligibleInstaPayVisit,
  formatCentsToDollars,
  formatToDate,
  formatVisitTimeRange,
  MotionFlex,
  VisitCard,
  VisitDate,
  VisitPrice,
  VisitTimeRange,
} from "../SelectInstaPayVisitsScreen";

export default function SelectEligibleVisitsCard(props: {
  visits: EligibleInstaPayVisit[];
  selected: HashSet<EligibleInstaPayVisit>;
  onChange: (visit: EligibleInstaPayVisit) => void;
}) {
  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle style={{ width: "100%" }}>
          <Flex direction="column">
            <div>{translate(STRINGS.ELIGIBLE_VISITS)}</div>
            <NotesText>{translate(STRINGS.SELECT_VISITS_FOR_INSTAPAY)}</NotesText>
          </Flex>
        </AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        {props.visits.length === 0 && (
          <Flex justifyContent="center" alignItems="center">
            <Padding p={16}>
              <NotesText>{translate(STRINGS.NO_ELIGIBLE_VISITS)}</NotesText>
            </Padding>
          </Flex>
        )}

        <Flex direction="column" gap={8}>
          {props.visits.map((visit) => (
            <VisitCard
              key={`${visit.id}`}
              isSelected={props.selected.has(visit)}
              onClick={() => props.onChange(visit)}
            >
              <AppListItem
                title={
                  <MotionFlex gap={8} alignItems="center">
                    <motion.div
                      initial={{ scale: 0 }}
                      animate={props.selected.has(visit) ? { scale: 1 } : { scale: 0, width: 0 }}
                      exit={{ scale: 0 }}
                    >
                      <AppIcon icon={CHECK_CIRCLE} fill="primary" />
                    </motion.div>
                    <motion.div transition={{ duration: 0.2 }}>
                      <Flex direction="column" gap={4}>
                        <VisitDate>{formatToDate(visit.startTime)}</VisitDate>
                        <VisitTimeRange>{formatVisitTimeRange(visit)}</VisitTimeRange>
                      </Flex>
                    </motion.div>
                  </MotionFlex>
                }
                trailing={
                  <VisitPrice>{formatCentsToDollars(visit.status.eligibleAmount)}</VisitPrice>
                }
              />
            </VisitCard>
          ))}
        </Flex>
      </AppCardContent>
    </AppCard>
  );
}
